import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const OrderOutlineIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      className="with_stroke"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6431 20.2143L21.0716 16.7857L17.6431 13.3572"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M21.0716 12.5V7.35711C21.0716 6.90245 20.891 6.46642 20.5695 6.14492C20.248 5.82343 19.8119 5.64282 19.3573 5.64282L5.643 5.64282C5.18834 5.64282 4.7523 5.82343 4.43081 6.14492C4.10932 6.46642 3.92871 6.90245 3.92871 7.35711L3.92871 19.3571C3.92871 19.8118 4.10932 20.2478 4.43081 20.5693C4.7523 20.8908 5.18834 21.0714 5.643 21.0714H13.3573"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M9.07129 5.64296V3.07153"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M15.9287 5.64296V3.07153"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M21.0716 9.07153L3.92871 9.07153"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
      />
      <path
        d="M20.2141 16.7849L21.0712 16.7858L13.3569 16.7858"
        stroke={color}
        strokeWidth="2.05714"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
    </svg>
  );
};
